module.exports = __webpack_public_path__ + "img/crash@2x.06f95c80.png";